export const alertStyles = {
  display: "flex",
  alignItems: "center",
  minWidth: { xs: "213px", sm: "313px" },
  maxWidth: "700px",
  height: "fit-content",
  borderRadius: "4px",
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "12px",
  boxShadow: "none",
};
